import React from 'react'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import '@videojs/themes/dist/fantasy/index.css'
import qualityLevels from 'videojs-contrib-quality-levels'
import hlsQualitySelector from 'videojs-hls-quality-selector'

export const VideoJS = (props) => {
  const videoRef = React.useRef(null)
  const playerRef = React.useRef(null)
  const { options, onReady, cover, onClickRedirect = () => {} } = props

  React.useEffect(() => {
    videojs.registerPlugin('qualityLevels', qualityLevels)
    videojs.registerPlugin('hlsQualitySelector', hlsQualitySelector)
    // make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = videoRef.current
      if (!videoElement) return
      const player = (playerRef.current = videojs(videoElement, options, () => {
        onReady && onReady(player)
      }))
    } else {
      // update the existing player only when the actual source has changed,
      // otherwise a reused instance keeps playing/stuck on the previous video
      const player = playerRef.current
      const newSrc = options.sources?.[0]?.src
      if (newSrc && newSrc !== player.currentSrc()) {
        player.poster(options.poster)
        player.muted(options.muted)
        player.autoplay(options.autoplay)
        player.src(options.sources)
      }
    }
  }, [options, videoRef])

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current

    return () => {
      if (player) {
        player.dispose()
        playerRef.current = null
      }
    }
  }, [playerRef])

  let coverCss = cover ? { objectFit: 'cover' } : { objectFit: '' }

  return (
    <div data-vjs-player="">
      <video
        ref={videoRef}
        style={coverCss}
        className="video-js vjs-fill vjs-big-play-centered object-cove vjs-theme-fantasy"
        onClick={onClickRedirect}
      />
    </div>
  )
}

export default VideoJS
